import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
var AspectRatio = styled(Box).withConfig({
  componentId: "sc-16gcddl-0"
})(["position:relative;max-width:100%;&::before{content:'';height:0;display:block;padding-bottom:", "%;}&::after{content:'';display:table;clear:both;}& > *:not(style){overflow:hidden;position:absolute;inset:0;display:flex;justify-content:center;align-items:center;width:100%;height:100%;}& > img,& > video{object-fit:cover;}"], function (_ref) {
  var _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? 1 : _ref$ratio;
  return 1 / ratio * 100;
});
export { AspectRatio };